import { useQuery } from "@tanstack/react-query";

import { GINO_QUERY_KEYS } from "../queryKeys";
import { getGinoCredits } from "../services/ginoCredits";

export const useGetGinoCredits = () => {
  return useQuery({
    queryKey: GINO_QUERY_KEYS.GINO_CREDITS,
    queryFn: getGinoCredits,
  });
};
